import qs from 'qs'
import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import {
  FILE_UPLOAD_URL,
  RETURN_ORDER_SEARCH_URL,
  RETURN_WORK_SCAN_ITEMS_URL,
  RETURN_WORK_SCAN_SAVE_URL,
  RETURN_WORK_SCAN_SUMMARY_URL,
} from './endpoints'
import {
  FileUploadCompleteReq,
  FileUploadCompleteRes,
  FileUploadPresignReq,
  FileUploadPresignRes,
  ReturnOrderSearchFilter,
  ReturnOrderSearchRes,
  ReturnWorkScanHeadFilter,
  ReturnWorkScanHeadRes,
  ReturnWorkScanItemFilter,
  ReturnWorkScanItemRes,
  ReturnWorkScanSaveReq,
  ReturnWorkScanSaveRes,
} from './types'

/** HEAD 조회 — 4개 파라미터 전부 필수(BE 가 전 화주·전 기간 조회를 400 으로 막는다). */
export const getReturnWorkScanSummary = (filter: ReturnWorkScanHeadFilter) =>
  request.get<ApiResponseV2<{ items: ReturnWorkScanHeadRes[] }>, ReturnWorkScanHeadFilter>(RETURN_WORK_SCAN_SUMMARY_URL, filter)

/** ITEM 조회 — `flag=true`(마스터 조회) 경로는 `trsInvoiceNo`·출고일자를 실제로 쓰지 않는다. */
export const getReturnWorkScanItems = (filter: ReturnWorkScanItemFilter) =>
  request.get<ApiResponseV2<{ items: ReturnWorkScanItemRes[] }>, ReturnWorkScanItemFilter>(RETURN_WORK_SCAN_ITEMS_URL, filter)

/** 저장 — 성공해도 `duplicateOrderNumbers` 가 채워질 수 있다(6단계). */
export const saveReturnWorkScan = (body: ReturnWorkScanSaveReq) =>
  request.post<ApiResponseV2<ReturnWorkScanSaveRes>, ReturnWorkScanSaveReq>(RETURN_WORK_SCAN_SAVE_URL, body)

/**
 * 주문검색 — `barcode`·`refNo1` 은 다건이라 `key=a&key=b` 로 편다. BE 가 `List<String>` 으로 받는다.
 * 공용 `Utils.qsStringify` 는 `arrayFormat: 'comma'` 라 이 계약에 맞지 않는다(`returnReceipt/apis.ts` 와 같은 이유).
 */
const toOrderSearchQuery = (filter: ReturnOrderSearchFilter): string =>
  qs.stringify(filter, { arrayFormat: 'repeat', skipNulls: true, filter: (_, value) => (value === '' ? undefined : value) })

export const getReturnOrderSearch = (filter: ReturnOrderSearchFilter) =>
  request.get<ApiResponseV2<{ items: ReturnOrderSearchRes[] }>>(`${RETURN_ORDER_SEARCH_URL}?${toOrderSearchQuery(filter)}`)

/**
 * 파일 업로드 1단계 — presigned URL 발급. 2단계(S3 PUT)는 `fileUpload.ts` 가 `@/utils/request` 없이
 * 순수 `fetch` 로 처리한다(인터셉터가 Authorization 을 붙이면 S3 서명이 깨진다).
 */
export const requestFileUploadPresign = (body: FileUploadPresignReq) =>
  request.post<ApiResponseV2<FileUploadPresignRes>, FileUploadPresignReq>(FILE_UPLOAD_URL, body, menuCodeHeaders('RGR17'))

/** 파일 업로드 3단계 — 대상 행의 `FILE_ID` 를 서버가 직접 갱신한다. */
export const completeFileUpload = (body: FileUploadCompleteReq) =>
  request.patch<ApiResponseV2<FileUploadCompleteRes>, FileUploadCompleteReq>(FILE_UPLOAD_URL, body, menuCodeHeaders('RGR17'))
